<template>
  <div class="container-fluid">
    <h5 class="my-3">Ausarbeitung für:</h5>
    <div class="row">
      <div class="col-12 col-md-6">Firma:</div>
      <div class="col-12 col-md-6">
        {{ customer.company_name }}
      </div>
      <div class="col-12 col-md-6">Staße:</div>
      <div class="col-12 col-md-6">
        {{ customer.street }}
      </div>
      <div class="col-12 col-md-6">PLZ/Ort:</div>
      <div class="col-12 col-md-6">
        {{ customer.city }}
      </div>
      <div class="col-12 col-md-6">Land:</div>
      <div class="col-12 col-md-6">
        {{ customer.country }}
      </div>
      <div class="col-12 col-md-6 mt-2">Ansprechpartner:</div>
      <div class="col-12 col-md-6">
        {{ customer.name }}
      </div>
      <div class="col-12 col-md-6">Telefon:</div>
      <div class="col-12 col-md-6">
        {{ customer.phone }}
      </div>
      <div class="col-12 col-md-6">Mobil:</div>
      <div class="col-12 col-md-6">
        {{ customer.mobile }}
      </div>
      <div class="col-12 col-md-6">Fax:</div>
      <div class="col-12 col-md-6">
        {{ customer.fax }}
      </div>
      <div class="col-12 col-md-6">E-Mail:</div>
      <div class="col-12 col-md-6">
        {{ customer.email }}
      </div>
    </div>
    <h5 class="my-3">Ausarbeitung von:</h5>
    <div class="row">
      <div class="col-12 col-md-6">Firma:</div>
      <div class="col-12 col-md-6">
        {{ creator.company_name }}
      </div>
      <div class="col-12 col-md-6">Staße:</div>
      <div class="col-12 col-md-6">
        {{ creator.street }}
      </div>
      <div class="col-12 col-md-6">PLZ/Ort:</div>
      <div class="col-12 col-md-6">
        {{ creator.city }}
      </div>
      <div class="col-12 col-md-6">Land:</div>
      <div class="col-12 col-md-6">
        {{ creator.country }}
      </div>
      <div class="col-12 col-md-6 mt-2">Ansprechpartner:</div>
      <div class="col-12 col-md-6">
        {{ creator.name }}
      </div>
      <div class="col-12 col-md-6">Telefon:</div>
      <div class="col-12 col-md-6">
        {{ creator.phone }}
      </div>
      <div class="col-12 col-md-6">Mobil:</div>
      <div class="col-12 col-md-6">
        {{ creator.mobile }}
      </div>
      <div class="col-12 col-md-6">Fax:</div>
      <div class="col-12 col-md-6">
        {{ creator.fax }}
      </div>
      <div class="col-12 col-md-6">E-Mail:</div>
      <div class="col-12 col-md-6">
        {{ creator.email }}
      </div>
    </div>
    <h5 class="my-3">Projektdaten</h5>
    <div class="row">
      <div class="col-12 col-md-6">Projektbezeichnung:</div>
      <div class="col-12 col-md-6">
        {{ project.name }}
      </div>
      <div class="col-12 col-md-6">Projektnummer:</div>
      <div class="col-12 col-md-6">
        {{ project.number }}
      </div>
      <div class="col-12 col-md-6">Bearbeiter:</div>
      <div class="col-12 col-md-6">
        {{ configuration.editor }}
      </div>
      <div class="col-12 col-md-6">Straße:</div>
      <div class="col-12 col-md-6">
        {{ project.street }}
      </div>
      <div class="col-12 col-md-6">PLZ/Ort:</div>
      <div class="col-12 col-md-6">
        {{ project.post_code ?? "" }} {{ project.city ?? "" }}
      </div>
      <div class="col-12 col-md-6">Land:</div>
      <div class="col-12 col-md-6">
        {{ this.getCountry(project.country) }}
      </div>
    </div>
  </div>
</template>

<script>
import Configuration from "@models/project/Configuration";
import Project from "@models/project/Project";

export default {
  data() {
    return {
      creator: {
        company_name: "",
        street: "",
        city: "",
        name: "",
        phone: "",
        mobile: "",
        fax: "",
        email: "",
        country: "",
      },

      customer: {
        company_name: "",
        street: "",
        city: "",
        name: "",
        phone: "",
        mobile: "",
        fax: "",
        email: "",
        country: "",
      },
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.session.user;
      },
    },
    configuration() {
      return Configuration.query().with("project").first();
    },
    project() {
      if (this.configuration) {
        return Project.query().where("id", this.configuration.project_id).with("contact").first();
      } else return null;
    },
    localization: {
      get() {
        return this.$store.state.localization.values;
      },
    },
  },
  methods: {
    setUser() {
      this.creator = {
        company_name: this.user.company_name,
        street: this.user.street,
        city: [this.user.post_code, this.user.city].filter(Boolean).join(" "),
        name: [this.user.first_name, this.user.last_name].filter(Boolean).join(" "),
        phone: this.user.company_phone,
        mobile: this.user.company_mobile,
        fax: this.user.company_fax,
        email: this.user.email,
        country: this.getCountry(this.user.country_id),
      };
      if (this.project && this.project.contact) {
        const contact = this.project.contact;
        this.customer = {
          company_name: contact.company_name,
          street: this.project.street,
          city: [this.project.post_code, this.project.city].filter(Boolean).join(" "),
          name: [contact.first_name, contact.last_name].filter(Boolean).join(" "),
          phone: contact.phone,
          mobile: contact.mobile,
          fax: "",
          email: contact.email,
          country: this.getCountry(this.project.country),
        };
      }
    },
    getCountry(id) {
      const country = this.localization.countries.find((country) => country.id === id);
      return country ? country.name : "";
    },
  },
  created() {
    this.setUser();
  },
};
</script>
